import { useContext } from 'react';

import { flexRender } from '@tanstack/react-table';
import clsx from 'clsx';

// Types
import { CompoundTableContext } from '@/components/base/Table/CompoundTable';

function TableFooter() {
    const { table } = useContext(CompoundTableContext);
    return (
        <tfoot className="sticky bottom-0 z-10 bg-white">
            {table.getFooterGroups().map((footerGroup) => (
                <tr key={footerGroup.id}>
                    {footerGroup.headers.map((header) => (
                        <th
                            key={header.id}
                            className={clsx(
                                'h-8 border-t border-icoGray-300 text-right dark:border-icoDarkMode-beton',
                                {
                                    'sticky left-0 z-1': header.column.columnDef.meta?.isSticky
                                }
                            )}>
                            {flexRender(header.column.columnDef.footer, header.getContext())}
                        </th>
                    ))}
                </tr>
            ))}
        </tfoot>
    );
}

export default TableFooter;
